import { squawkQuery } from "@common/api/quoting/squawk"
import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute } from "@tanstack/react-router"
import { SquawkPaneRoute } from "./-components/squawk-pane"

export const Route = createFileRoute("/_layout/quoting_/squawks/$squawkId")({
  staticData: { detailSidebar: true },
  loader: ({ context: { queryClient }, params: { squawkId } }) =>
    queryClient.ensureQueryData(squawkQuery({ squawk_id: squawkId })),
  component: SquawkRoute,
})

function SquawkRoute(): React.ReactElement {
  const { squawkId } = Route.useParams()
  const { data: squawk } = useSuspenseQuery(
    squawkQuery({ squawk_id: squawkId }),
  )
  return <SquawkPaneRoute key={squawk.id} squawk={squawk} />
}
